export default "__VITE_ASSET__VOvbiKsi__"